import axios from 'axios';

const BUILDER_ENV: Record<string, string> = {
  'builder.vidapp.com': 'https://builder-api.vidapp.com',
  'uat.vidapp.com': 'https://builder-api-uat.vidapp.com',
};
export const APP_BUILDER_API_URL = BUILDER_ENV[window.location.host] ?? 'https://builder-api-uat.vidapp.com';
const client = axios.create();

export interface OnboardingAnswers {
  FirstName: string;
  LastName: string;
  BestFit: string[] | string; // String[] in Form, Combined into string for API
  BusinessName: string;
  Email: string;
  Password: string;
  HeardAboutUs: string;
  Confirmed: boolean; // Terms and conditions checkbox
  RewardfulId?: string;
  // Has membership site
  DataSource?: string;
  MemberCount?: string;
  // Has no membership site
  SocialHandle?: string;
  FollowerCount?: string;
}

export const submitOnboarding = async (
  {
    FirstName,
    LastName,
    BestFit,
    DataSource,
    MemberCount,
    HeardAboutUs,
    Email,
    Password,
    SocialHandle,
    FollowerCount,
    BusinessName,
    RewardfulId,
  }: OnboardingAnswers,
  createApp = false,
  hasExistingMembershipSite = true,
) => {
  let requestUrl = '';
  let payload: Partial<OnboardingAnswers> = {
    FirstName,
    LastName,
    BestFit: Array.isArray(BestFit) ? BestFit.join(', ') : BestFit,
    BusinessName,
    Email,
    Password,
    HeardAboutUs,
  };
  if (hasExistingMembershipSite) {
    payload = { ...payload, DataSource, MemberCount };
  } else {
    payload = { ...payload, FollowerCount, SocialHandle };
  }
  if (RewardfulId) {
    payload.RewardfulId = RewardfulId;
  }

  if (createApp) {
    // Creates a new app
    requestUrl = `${APP_BUILDER_API_URL}/api/v1/onboarding/signup`;
  } else {
    // Saves the lead details and creates a builder user
    requestUrl = `${APP_BUILDER_API_URL}/api/v1/onboarding/lead`;
  }
  return client
    .post(requestUrl, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    })
    .catch((err) => {
      console.error(err);
      return err.response;
    });
};

export const refreshToken = () => {
  return client.post(`${APP_BUILDER_API_URL}/api/v1/auth/token/refresh`, {}, { withCredentials: true });
};

export const validateEmailOnServer = (email: string) => {
  return client.post(`${APP_BUILDER_API_URL}/api/v1/onboarding/validate-email`, { Email: email }).catch((err) => {
    console.error(err);
    return err.response;
  });
};
